import { createSlice } from '@reduxjs/toolkit';
import { Moment } from 'moment';

export interface AclState {
	isLoading: boolean;
	consentProvided: boolean;
	createdAt?: Moment;
}

const initialState: AclState = {
	isLoading: false,
	consentProvided: false,
	createdAt: undefined,
};

export const patientConsentSlice = createSlice({
	name: 'patientConsent',
	initialState,
	reducers: {
		setPatientConsentIsLoading: (state, { payload }) => {
			state.isLoading = payload;
		},
		setPatientConsentProvided: (state, { payload }) => {
			state.consentProvided = payload;
		},
		setPatientConsentCreatedAt: (state, { payload }) => {
			state.createdAt = payload;
		},
	},
});

export const {
	setPatientConsentIsLoading,
	setPatientConsentProvided,
	setPatientConsentCreatedAt,
} = patientConsentSlice.actions;
export const selectPatientConsentIsLoading = (state: any) =>
	state.patientConsent.isLoading;
export const selectConsentProvided = (state: any) =>
	state.patientConsent.consentProvided;
export const selectConsentCreatedAt = (state: any) =>
	state.patientConsent.createdAt;

export default patientConsentSlice.reducer;
